{
  "//vg-binding": "CONTEXT:decisions=P6.1.D-28,P6.1.D-20 | INTERFACE-STANDARDS:error-shape",
  "spending": {
    "label": "Hạn mức chi tiêu của team",
    "summary": "Đã chi {{spent}} / {{limit}} mỗi tháng",
    "noLimit": "Đã chi {{spent}} · chưa đặt hạn mức"
  },
  "tabs": {
    "stores": "Cửa hàng ({{count}})",
    "members": "Thành viên ({{count}})"
  },
  "stores": {
    "title": "Cửa hàng đã gán",
    "assign": "Gán cửa hàng",
    "empty": "Chưa có cửa hàng nào được gán"
  },
  "store": {
    "Connected": "Đã kết nối",
    "Disconnected": "Đã ngắt kết nối",
    "remove": "Gỡ"
  },
  "members": {
    "empty": "Chưa có thành viên nào trong team này"
  },
  "assign": {
    "title": "Gán cửa hàng vào team",
    "subtitle": "Chọn những cửa hàng mà team này được thấy. Thao tác này sẽ thay thế lựa chọn hiện tại.",
    "unassignedBadge": "Chưa gán",
    "save": "Lưu",
    "saving": "Đang lưu..."
  },
  "toast": {
    "storesAssigned": "Đã gán cửa hàng",
    "storeRemoved": "Đã gỡ cửa hàng",
    "assignFailed": "Không thể cập nhật việc gán cửa hàng",
    "staleConflict": "Việc gán đã thay đổi kể từ khi bạn mở — đang làm mới. Vui lòng xem lại và thử lại.",
    "crossTeamConflict": "\"{{store}}\" đã thuộc về một team khác. Hãy gỡ khỏi team đó trước."
  },
  "empty": {
    "notFound": {
      "title": "Không tìm thấy team",
      "body": "Team này có thể đã bị ngừng hoạt động hoặc liên kết không hợp lệ.",
      "back": "Quay lại danh sách Team"
    }
  },
  "error": {
    "loadFailed": "Không thể tải team này.",
    "retry": "Thử lại",
    "forbidden": {
      "title": "Từ chối truy cập",
      "body": "Bạn không có quyền xem team này. Vui lòng liên hệ chủ shop."
    }
  }
}
